import Player from "./component/Player"

function App() {
  return (
    <div className="App">
      <div className="music-card">
        <Player />
      </div>
    </div>
  );
}

export default App;
